import React from "react";

const AlertText = ({ message }) => {
  return <div className="myalert">{message}</div>;
};

export default AlertText;
